export const selectPortData = (state) => state.portData.data;

export const selectFilterData = (state) => state.portData.filterData;